import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';
import quiz from './modules/quiz';
import kofferspel from './modules/kofferspel';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        entry,
        quiz,
        kofferspel
    },

    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    }
});
